<template>
    <div>
        <div class="cgs-worksheet-header">
        <van-nav-bar
        title="系统设置"
        left-text="返回"
        left-arrow
        @click-left="goBack"
        />
        </div>
        <div class="cgsLoginPage">  
            <div class="cgsLogo">
                <img :src="require('@/assets/image/iconLogo.png')" width="100px">
            </div>
            <div style="width:80%;margin: 0px auto;">
                <div class="text">系统设置</div>
                <div class="text1">请访问私有部署网页端App设置网页获取配置信息</div>
            </div>
        </div>
        <div class="i">
            <div>
             <van-field style="width: 300px;" v-model="baseURL" clearable placeholder="手动输入" />
            </div>
            <div class="yes">
                <van-button type="info" style="width: 100%" @click="setBaseURL">确定</van-button>
            </div>
        </div>
    </div>
</template>

<script>
import { NavBar,Button,Field  } from 'vant';
import request from "@/axios"
import {getBaseURL, setBaseURL} from "@/util/appConfigura"

export default {
    components:{
        vanNavBar: NavBar,
        vanButton: Button,
        vanField: Field, 
    },
    data () {
        return {
            baseURL:''
        }
    },
    created(){
        let _baseURL = getBaseURL()
        this.baseURL = _baseURL || ''
    },
    methods: {
        goBack(){
           this.$router.go(-1); 
        },
        setBaseURL(){
            setBaseURL(this.baseURL)
            if(this.baseURL === ''){
                let _envBaseURL = process.env.VUE_APP_NODE_ENV==='development'?'':process.env.VUE_APP_BASEURL
                request.defaults.baseURL = _envBaseURL
            } else {
                request.defaults.baseURL = this.baseURL
            }
            this.goBack()
        }
    }
}
</script>

<style>
.cgs-worksheet-header {
  /* color: #fff; */
  border-bottom: 1px solid #cfcfcf;
}
.cgsLoginPage .cgsLogo{
    /* width: 100%;
    height: 30%; */
    text-align: center;
    padding: 50px;
}
.yes{
    padding: 10px 16px;
}
.text{
    text-align: center;
}
.text1{
    text-align: center;
    margin: 10px 0px;
}
.i{
    padding: 30px;
}
</style>